
import SystemCode from "@/store/modules/system/customersystemcode/entity";
import { Component, Mixins, ActionButtonConfig, FormModalMixins,appConst} from "@/lib";
import {systemConst} from '@/lib/consts/modules/system'

@Component({name:"edit-option-modal"})
export default class EditSystemCode extends Mixins(FormModalMixins) {
  model = new SystemCode();
  created() {
    Object.assign(this.config, { modelTitleL: "Action.Edit",labelWidth:130, okAction: "system/customersystemcode/update", width:660 });
  }

 
  get record(){
        return this.$store.state.system.customersystemcode.editSystemCode;
    }

  get categoryList() {
         return this.getCodeListByCategory(
      appConst.codeCategory.category
    )}
  
}
